// @flow
import { useEffect, useState } from "react";
import * as React from "react";
import { paginate } from "../../../util/paginate";

interface Props {
  onPageChange: (pageNumber: number) => void;
  onPageSizeChange: (pageSize: number) => void;

  itemsCount: number;
  currentPage: number;
  pages: number[];
  pageSize: number;
}

export const PaginationComponent = (props: Props) => {
  const { onPageChange, currentPage, pages, pageSize, onPageSizeChange } =
    props;
  const [paginatedPages, setPaginatedPages] = useState([]);
  const totalPages = pages.length;

  useEffect(() => {
    setPaginatedPages(paginate(pages, 1, 5));
  }, [pages]);

  useEffect(() => {
    setPaginatedPages(paginate(pages, Math.ceil(currentPage / 5), 5));
  }, [currentPage]);

  const handleChange = (e) => {
    const { value } = e.target;
    onPageSizeChange(value);
  };

  return (
    <section className="center-align" style={{ paddingTop: "5px" }}>
      <ul
        className="pagination"
        style={{
          display: "inline-block",
          paddingLeft: "0px",
          margin: "20px 0px",
          borderRadius: "4px",
        }}
      >
        <li style={{ padding: "5px" }}>Show Records</li>
        <li
          style={{
            marginRight: "10px",
            border: "1px solid rgb(221, 221, 221)",
            borderRadius: "4px",
          }}
        >
          <select
            className="browser-default"
            style={{ height: "32px" }}
            onChange={handleChange}
            value={pageSize}
          >
            <option value="10">
              10
            </option>
            <option value="25">
              25
            </option>
            <option value="50">
              50
            </option>
            <option value="75">
              75
            </option>
            <option value="100">
              100
            </option>
            <option value="100000">
              All
            </option>
          </select>
        </li>
        <li className={currentPage === 1 ? "disabled" : ""}>
          <a
            onClick={() => onPageChange(1)}
            style={{
              cursor: "pointer",
              marginLeft: "0px",
              borderTopLeftRadius: "4px",
              borderBottomLeftRadius: "4px",
              color: "#337ab7",
              border: "1px solid #ddd",
            }}
          >
            First
          </a>
        </li>
        <li className={currentPage === 1 ? "disabled" : ""}>
          <a
            onClick={() => {
              if (currentPage > 1) {
                onPageChange(currentPage - 1)
              }
            }}
            style={{
              cursor: "pointer",
              color: "#337ab7",
              border: "1px solid #ddd",
            }}
          >
            Previous
          </a>
        </li>
        {paginatedPages.map((page, index) => (
          <li key={index} className={currentPage === page ? "active" : ""}>
            <a
              onClick={() => onPageChange(page)}
              style={{
                cursor: "pointer",
                color: "#337ab7",
                border: "1px solid #ddd",
              }}
            >
              {page}
            </a>
          </li>
        ))}
        <li className={currentPage === totalPages ? "disabled" : ""}>
          <a
            onClick={() => {
              if (currentPage < totalPages) {
                onPageChange(currentPage + 1)
              }
            }}
            style={{
              cursor: "pointer",
              color: "#337ab7",
              border: "1px solid #ddd",
            }}
          >
            Next
          </a>
        </li>
        <li className={currentPage === totalPages ? "disabled" : ""}>
          <a
            onClick={() => onPageChange(totalPages)}
            style={{
              cursor: "pointer",
              color: "#337ab7",
              border: "1px solid #ddd",
            }}
          >
            Last
          </a>
        </li>
      </ul>
    </section>
  );
};
